import * as React from "react"
import CreatableSelect from 'react-select/creatable'


export default function MultiInputTag({ ...props }) {

    const myProps = {
        components: { DropdownIndicator: null }, 
		isClearable: true, 
		isMulti: true, 
        menuIsOpen: false, 
		placeholder: "Insert elements", 
		styles: {
			control: provided => ({
				...provided,
				height: '100%', 
				minHeight: '33px',
				marginTop: '6px',
                borderRadius: '6px'
			})
		},
		...props
    }

    return <div style={{ position: 'relative' }}>
		{ props.label && <label htmlFor="tag-select" 
			style={{ 
				marginBottom: '8px',
				position: 'absolute',
				transform: 'translateY(-50%)',
				left: '10px',
				top: '-1px',
				zIndex: '10',
				width: 'auto',
				display: 'inline-block',
				padding: '3px 4px',
				fontSize: '10px',
				color: 'hsl(0, 0%, 80%)',
				backgroundColor: 'white',
				transition: 'all 0.3s'
			}}
		>
			{props.label}
		</label> }
		<CreatableSelect {...myProps} />
	</div>
}